import { thousandSeparated } from 'shared/util/formatting';

import { SearchResultsSortDropdown } from '../searchResultsSortDropdown/SearchResultsSortDropdown';
import { HotelBreadcrumbs, type HotelBreadcrumbProps } from '@/components/hotelBreadcrumbs/HotelBreadcrumbs';
import type { SearchConfig, SearchDestination } from '@/interfaces';

export interface TopBarDesktopProps {
    destination: SearchDestination;
    numberOfHotels: number;
    searchConfig?: SearchConfig;
}

export const TopBarDesktop = ({ destination, numberOfHotels, searchConfig }: TopBarDesktopProps) => {
    const name = destination?.hierarchy?.[destination.hierarchy.length - 1]?.name || destination?.name;
    const place: HotelBreadcrumbProps['place'] = {
        name,
        key: destination?.key,
    };
    return (
        <div className="panel grid u-hide-lt768" data-testid="topbar-desktop">
            <div className="grid__unit u-pt16 u-size1of3">
                <HotelBreadcrumbs place={place} searchConfig={searchConfig} />
            </div>
            <div className="grid__unit u-size2of3">
                <output className="u-size1of2 u-text-center u-float-left u-mt16" data-testid="resultCount">
                    <span className="u-strong">{numberOfHotels ? thousandSeparated(numberOfHotels) : '0'}</span> hoteller
                </output>
                <div className="u-size1of2 u-float-right">
                    <SearchResultsSortDropdown id="sortDropdownDesktop" horizontal />
                </div>
            </div>
        </div>
    );
};
